import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetSegmentos() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getSegmentos = useCallback(
        (descricao: string, query?: string) => invocarApi({
            url: `v1/segmento?Descricao=${'%' + descricao + '%'}&page=1${query}`,
            method: 'GET',
            enviarTokenUsuario: false,
            baseURL: 'https://api-segmentos-prod.touchone.com.br/api/',
        }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getSegmentos,
    };
}
